module.exports = {
  "wxc-search-bar": {
    "paddingLeft": 20,
    "paddingRight": 20,
    "backgroundColor": "#ffffff",
    "width": 750,
    "height": 84,
    "flexDirection": "row"
  },
  "wxc-search-bar-yellow": {
    "backgroundColor": "#ffc900"
  },
  "search-bar-input": {
    "position": "absolute",
    "top": 10,
    "paddingTop": 0,
    "paddingBottom": 0,
    "paddingRight": 40,
    "paddingLeft": 60,
    "fontSize": 26,
    "width": 624,
    "height": 64,
    "lineHeight": 64,
    "backgroundColor": "#E5E5E5",
    "outline": "none",
    "borderRadius": 6
  },
  "search-bar-input-yellow": {
    "backgroundColor": "#fff6d6",
    "placeholderColor": "#666666"
  },
  "search-bar-icon": {
    "position": "absolute",
    "width": 30,
    "height": 30,
    "left": 34,
    "top": 28
  },
  "search-bar-close": {
    "position": "absolute",
    "width": 30,
    "height": 30,
    "right": 120,
    "top": 28
  },
  "search-bar-button": {
    "width": 94,
    "height": 36,
    "fontSize": 30,
    "textAlign": "center",
    "backgroundColor": "#ffffff",
    "marginTop": 16,
    "marginRight": 0,
    "color": "#333333",
    "position": "absolute",
    "right": 8,
    "top": 9
  },
  "search-bar-button-yellow": {
    "backgroundColor": "#FFC900"
  },
  "input-has-dep": {
    "paddingLeft": 240,
    "width": 710
  },
  "bar-dep": {
    "width": 170,
    "paddingRight": 12,
    "paddingLeft": 12,
    "height": 42,
    "alignItems": "center",
    "flexDirection": "row",
    "position": "absolute",
    "left": 24,
    "top": 22,
    "borderRightStyle": "solid",
    "borderRightWidth": 1,
    "borderRightColor": "#C7C7C7"
  },
  "bar-dep-yellow": {
    "borderRightColor": "#C7C7C7"
  },
  "dep-text": {
    "flex": 1,
    "textAlign": "center",
    "fontSize": 26,
    "color": "#666666",
    "marginRight": 6,
    "lines": 1,
    "textOverflow": "ellipsis"
  },
  "dep-arrow": {
    "width": 24,
    "height": 24
  },
  "icon-has-dep": {
    "left": 214
  },
  "disabled-input": {
    "width": 750,
    "height": 64,
    "position": "absolute",
    "left": 0,
    "backgroundColor": "rgba(0,0,0,0)"
  },
  "has-dep-disabled": {
    "width": 550,
    "left": 200
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/weex-vue-loader/lib/style-loader.js!./node_modules/weex-vue-loader/lib/style-rewriter.js?id=data-v-345d16ef!./node_modules/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/wxc-searchbar/index.vue
// module id = 173
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28